import axios from 'axios';
import { StoreListingModel } from '../models/StoreListingModel';

const API_URL = process.env.REACT_APP_API_URL;
const STORE_LISTING_URL = `${API_URL}/api/store-listings/`;

export async function listStoreListings(): Promise<{
  data: StoreListingModel[];
}> {
  return axios.get(STORE_LISTING_URL);
}

export function updateStoreListing(
  storeListing: Partial<StoreListingModel> & { id: number }
): Promise<{ data: StoreListingModel }> {
  const { id, ...updateData } = storeListing;
  if (!id) {
    throw new Error('Store listing ID is required for update');
  }
  return axios.patch(`${STORE_LISTING_URL}${id}/`, updateData);
}

export interface CreateStoreListingParams {
  product: number;
  store: number;
  tax_class: number;
  price: number;
  state: 'active' | 'inactive';
}

export function createStoreListing(
  params: CreateStoreListingParams
): Promise<{ data: StoreListingModel }> {
  return axios.post(STORE_LISTING_URL, params);
}
